let ol = require('openlayers');

/**
 * Класс, представляющий источник данных (векторный) для утилитарных целей (рисование, управление интекактивностью и т.п.
 */
class EmptyVectorSource {
    constructor(params) {
        this.source = this.create(params);
        this.type = "EmptyVectorSource";
    }

    getSource() {
        return this.source;
    }

    setSource(source) {
        this.source = source;
    }

    create(params) {
        let source = new ol.source.Vector(params);
        return source;
    }
}

module.exports = EmptyVectorSource;